import MeriPhotoAlbum from './MeriPhotoAlbumBase.jsx';
import { installPhotoAlbumUploadCompression } from '../../utils/photoAlbumUploadCompression.js';
import { installPhotoAlbumPublicUploadDefault } from '../../utils/photoAlbumPublicUploadDefault.js';
import { installPhotoAlbumGuestIdentity } from '../../utils/photoAlbumGuestIdentity.js';
import { installPhotoAlbumGuestPreviewAuth } from '../../utils/photoAlbumGuestPreviewAuth.js';
import { installPhotoAlbumGuestUploadedPhotos } from '../../utils/photoAlbumGuestUploadedPhotos.js';
import { installPhotoAlbumCompactSelectedUpload } from '../../utils/photoAlbumCompactSelectedUpload.js';
import { installPhotoAlbumCropUpload } from '../../utils/photoAlbumCropUpload.js';
import { installPhotoAlbumCropPanBounds } from '../../utils/photoAlbumCropPanBounds.js';
import { installPhotoAlbumBookCenter } from '../../utils/photoAlbumBookCenter.js';
import { installPublicGalleryMosaicLayout } from '../../utils/publicGalleryMosaicLayout.js';
import { installPhotoAlbumSwipeNavigation } from '../../utils/photoAlbumSwipeNavigation.js';
import '../../styles/MeriPhotoAlbum/PhotoAlbumPrivacy.css';
import '../../styles/MeriPhotoAlbum/PublicPhotoGallery.css';
import '../../styles/MeriPhotoAlbum/PublicGalleryMosaic.css';
import '../../styles/MeriPhotoAlbum/PhotoAlbumCropUpload.css';
import '../../styles/MeriPhotoAlbum/PhotoAlbumCropPanBounds.css';
import '../../styles/MeriPhotoAlbum/PhotoAlbumGuestIdentity.css';
import '../../styles/MeriPhotoAlbum/PhotoAlbumGuestUploadedPhotos.css';
import '../../styles/MeriPhotoAlbum/PhotoAlbumCompactSelectedUpload.css';
import '../../styles/MeriPhotoAlbum/PhotoAlbumMobileBook.css';
import '../../styles/MeriPhotoAlbum/PhotoAlbumMobileUploadTap.css';
import '../../styles/MeriPhotoAlbum/PhotoAlbumBookCenter.css';

installPhotoAlbumUploadCompression();
installPhotoAlbumPublicUploadDefault();
// Install quota guarding before the crop listener so over-limit files are removed
// before any unnecessary crop dialogs are opened.
installPhotoAlbumGuestIdentity();
installPhotoAlbumGuestPreviewAuth();
installPhotoAlbumCropUpload();
installPhotoAlbumCropPanBounds();
installPhotoAlbumGuestUploadedPhotos();
installPhotoAlbumCompactSelectedUpload();
installPhotoAlbumBookCenter();
installPublicGalleryMosaicLayout();
installPhotoAlbumSwipeNavigation();

export default MeriPhotoAlbum;
